import React from 'react'
import ReactDOM from 'react-dom/client'
import { ForgeProvider, ToastProvider } from 'wss3-forge'
import 'wss3-forge/styles'
import './index.css'
import App from './App'
import { ThemeProvider, useThemeMode } from './contexts/ThemeContext'
import { AppThemeProvider, useAppTheme } from './contexts/AppThemeContext'

function ThemedApp() {
  const { mode } = useThemeMode()
  const { brandColor } = useAppTheme()

  return (
    <ForgeProvider
      mode={mode}
      theme={{
        brandPrimary: brandColor,
        brandSecondary: '#FD9173'
      }}
    >
      <ToastProvider position="bottom-right">
        <App />
      </ToastProvider>
    </ForgeProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppThemeProvider>
        <ThemedApp />
      </AppThemeProvider>
    </ThemeProvider>
  </React.StrictMode>
)
